import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { studentServices } from "../api/studentServices";
import CheckoutSkeleton from "../components/skeleton-loading/CheckoutSkeleton"; // Skeleton import edildi
import cardLogos from "../assets/card-logos.png";

export default function Checkout() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);
  const [studentData, setStudentData] = useState(null);

  const {
    userName = "-",
    schoolName = null,
    routeName = "Servis Rotası Belirtilmedi",
    installmentMonth = "Taksit Ödemesi",
    serviceAmount = 0,
    netAmount: netAmountParam,
    taxAmount: taxAmountParam,
    rawItem,
  } = location.state || {};

  const totalAmount = Number(serviceAmount) || 0;

  const netAmount =
    netAmountParam !== null && netAmountParam !== undefined
      ? Number(netAmountParam)
      : totalAmount / 1.2;

  const vatAmount =
    taxAmountParam !== null && taxAmountParam !== undefined
      ? Number(taxAmountParam)
      : totalAmount - netAmount;

  const vatPercentage =
    netAmount > 0 ? Math.round((vatAmount / netAmount) * 100) : 0;

  useEffect(() => {
    let isMounted = true;

    const getUserData = async () => {
      try {
        const studentResponse = await studentServices.getByToken();

        if (isMounted && studentResponse.data?.status) {
          setStudentData(studentResponse.data.data);
        }
      } catch (error) {
        console.error("Veri çekilirken hata oluştu:", error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    getUserData();

    return () => {
      isMounted = false;
    };
  }, []);

  if (isLoading) {
    return <CheckoutSkeleton />;
  }

  const displayUserName = studentData
    ? `${studentData.name} ${studentData.surname}`
    : userName;

  const displaySchoolName = studentData?.school_id?.name || schoolName;

  return (
    <div className="min-h-screen bg-[#f8f9ff] flex items-center justify-center p-4">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg border border-gray-100 p-6 sm:p-8">
        <div className="mb-6 pb-4 border-b border-gray-200 space-y-2">
          <div>
            <span className="block text-sm font-semibold text-gray-500">
              Öğrenci
            </span>
            <span className="text-lg font-bold text-blue-900">
              {displayUserName}
            </span>
          </div>

          {displaySchoolName && displaySchoolName !== "-" && (
            <div>
              <span className="block text-sm font-semibold text-gray-500">
                Okul
              </span>
              <span className="text-lg font-bold text-blue-900">
                {displaySchoolName}
              </span>
            </div>
          )}

          <div>
            <span className="block text-sm font-semibold text-gray-500">
              Servis Rotası
            </span>
            <span className="text-lg font-bold text-blue-900">{routeName}</span>
          </div>
        </div>

        <div className="mb-6 space-y-4">
          <div className="flex justify-between items-center">
            <span className="text-gray-700 font-semibold">Taksit Tarihi:</span>
            <span className="font-semibold text-gray-900">
              {installmentMonth}
            </span>
          </div>

          <div className="flex justify-between items-center">
            <span className="text-gray-700 font-semibold">Ödenen Tutar:</span>
            <span className="font-semibold text-gray-900">
              ₺
              {totalAmount.toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          </div>

          <div className="pl-4 border-l-2 border-gray-300 my-2 space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Servis Ücreti (Net)</span>
              <span className="text-sm font-medium text-gray-700">
                ₺
                {netAmount.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>

            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">
                KDV (%{vatPercentage} Dahil)
              </span>
              <span className="text-sm font-medium text-gray-700">
                ₺
                {vatAmount.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
          </div>

          <div className="h-[1px] bg-gray-200 my-3" />

          <div className="flex justify-between items-center">
            <span className="text-lg font-bold text-gray-900">
              Toplam Ödeme:
            </span>
            <span className="text-2xl font-extrabold text-blue-900">
              ₺
              {totalAmount.toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          </div>
        </div>

        <div className="w-full mt-6 space-y-3">
          <button
            type="button"
            onClick={() => {
              const posData = {
                rawItem,
              };
              navigate("/payment-webview", {
                state: {
                  posData,
                  rawItem,
                },
              });
            }}
            className="w-full bg-[#00306b] hover:bg-[#002452] py-4 mb-3 rounded-xl flex items-center justify-between shadow-md px-4 transition-colors cursor-pointer"
          >
            <span className="text-white text-xl font-bold">Kredi Kartı</span>
            <div className="bg-white px-2 py-1 rounded-lg flex items-center justify-center">
              <img
                src={cardLogos}
                alt="Kredi Kartları"
                className="h-5 object-contain"
              />
            </div>
          </button>

          <button
            type="button"
            onClick={() => navigate(-1)}
            className="w-full py-2 text-gray-600 hover:text-gray-900 font-semibold transition-colors cursor-pointer text-center"
          >
            İptal Et
          </button>
        </div>
      </div>
    </div>
  );
}
